import { useState } from "react";
import { UserUpdate } from "@/types/user";
import { userUpdate, userUpdateMobile } from "@/apis/user";
import { notification } from "antd";
import errorCodes from "@/apis/error";
import { useTranslation } from "react-i18next";

type UserUpdateApi = (userId: string, newInfo: UserUpdate) => Promise<void>;
type UserUpdateMobileApi = (userId: string, newInfo: UserUpdate) => Promise<void>;

type UseUserUpdate = () => [boolean, { userUpdate: UserUpdateApi, userUpdateMobile: UserUpdateMobileApi }];

const useUserUpdate: UseUserUpdate = () => {
  const { t } = useTranslation();
  const [changeLoading, setChangeLoading] = useState<boolean>(false);

  const handleUserUpdate: UserUpdateApi = (userId, newInfo) => {
    setChangeLoading(true);
    return new Promise<void>((resolve, reject) => {
      userUpdate(userId, newInfo)
        .then(() => resolve())
        .catch((err) => tipMess(err))
        .finally(() => setChangeLoading(false));
    });
  };

  const handleUserUpdateMobile: UserUpdateMobileApi = (userId, info) => {
    setChangeLoading(true);
    return new Promise<void>((resolve, reject) => {
      userUpdateMobile(userId, info)
        .then(() => resolve())
        .catch((err) => tipMess(err))
        .finally(() => setChangeLoading(false));
    }); 
  }

  const tipMess = (err: number) => {
    switch (err) {
      case 70204:
        notification.error({ placement: 'top', message: t('member.updateFail'), description: t('member.userDataNoExistTip')});
        break;
      default:
        notification.error({ placement: 'top', message: t('member.updateFail'), description: errorCodes[err] || err});
        break;
    }
  }

  return [changeLoading, { userUpdate: handleUserUpdate, userUpdateMobile: handleUserUpdateMobile }];
};

export default useUserUpdate;
